<div class="cygov-header" *cygovLoader="loading">
  <div class="left" [ngClass]="{'welcome-board': isWelcome}">
    <div class="logo-wrapper" (click)="goHomeByRole()">
      <div *ngIf="!isBnb" class="logo" cygovSvgIcon [svgName]="mainLogoName"></div>
      <img class="logo-img" *ngIf="isBnb" [src]="bnbLogoPath" alt="Brown and Brown" />
    </div>
  </div>

  <div class="right" [ngClass]="{'welcome-board': isWelcome}">
    <div *ngIf="isWelcome" class="guide">
      <div class="colored-circle" cygovSvgIcon [svgName]="'colored-circle2'" placement="left">
      </div>
      <div class="colored-arrow" cygovSvgIcon [svgName]="'colored-arrow'" placement="left">
      </div>
      <div class="lato-18-n-vw text">
        Dedicated short video guide for every page you are on in the platform
      </div>
    </div>
    <cygov-walkthrough-videos [currentRoute]="currentRoute">
    </cygov-walkthrough-videos>

    <cygov-support [ngClass]="{'apply-opacity': isWelcome}"></cygov-support>

    <!-- <div class="megaphone-wrapper">
      <div class="megaphone" cygovSvgIcon [svgName]="'megaphone'"></div>
      <span class="lato-12-n num-count">{{notificationCount}}</span>
    </div> -->

    <div ngbDropdown class="menu-dropdown">
      <button class="btn-type-link user-menu" [ngClass]="{'apply-opacity': isWelcome}"
        id="dropdownConfig" ngbDropdownToggle>
        <cygov-username-icon [username]="user.name" [height]="(5).toString()"></cygov-username-icon>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownConfig">
        <button class="dropdown-item capitalize" ngbDropdownItem
          (click)="openProfileModal(UpdateProfileContent, UpdateProfileFooter)">
          Edit Profile
        </button>

        <!-- <button class="dropdown-item capitalize" ngbDropdownItem *ngIf="isAdmin"
          (click)="navigateTo('admin/entity-list')">
          Entity List
        </button>
        <button class="dropdown-item capitalize" ngbDropdownItem *ngIf="isAdmin"
          (click)="openGeneratorModal()">
          Generator
        </button> -->
        <button class="dropdown-item capitalize" ngbDropdownItem *ngIf="isAdmin"
          (click)="navigateTo('binary-edge')">
          Binary Edge Services
        </button>
        <button class="dropdown-item capitalize" ngbDropdownItem *ngIf="isAdmin"
          (click)="openFrameworksSettings()">
          Instance Settings
        </button>
        <button class="dropdown-item capitalize" ngbDropdownItem (click)="signOut()">
          Sign Out
        </button>
      </div>
    </div>
    <div class="banner-rotator" *ngIf="isVendor">
      <cygov-vendor-advertisement-banner [bannerId]="1" [user]="user"
        [paragraphText]="'Discover how Centraleyes transforms risk management with AI-driven automation!'"
        [buttonText]="'Get Special Offer'" [bannerClass]="'bg-blue-gradient'">
      </cygov-vendor-advertisement-banner>

      <cygov-vendor-advertisement-banner [bannerId]="3" [user]="user"
        [paragraphText]="'Experience the Next Generation of GRC with Centraleyes!'"
        [buttonText]="'See it in Action'" [bannerClass]="'bg-blue-gradient'">
      </cygov-vendor-advertisement-banner>
    </div>

  </div>

</div>


<ng-template #UpdateProfileContent>
  @if(profileLoading) {
  <div class="profile-loading">
    <cygov-loader></cygov-loader>
  </div>
  }
  <div class="edit-profile-body">
    <div class="section user-name-section">
      <div class="label lato-14-n-vw">User Name</div>
      <div class="input-wrapper">
        <input type="text" class="lato-14-n-vw user-name-input" [(ngModel)]="user.name"
          placeholder="Enter user name" [readonly]="profileLoading" />
      </div>
    </div>

    @if(isAPIEnabled) {
    <div class="horizontal-divider"></div>
    @if(userTokenMetadata?.isTokenExists) {
    <div class="section api-key-section">
      <div class="section-title-row">
        <div class="d-flex">
          <div class="section-title lato-16-n-vw">API Key Generator</div>
          <div class="status lato-14-n-vw">
            &nbsp;|&nbsp; Status:
            <span class="active"
              [ngClass]="{'expired': userTokenMetadata?.status?.toLowerCase() !== 'active'}">{{userTokenMetadata?.status
              | titlecase}}</span>

            @if (userTokenMetadata?.status?.toLowerCase() === 'active') {
            <span class="expires">(Expires in {{userTokenMetadata?.expiresInDays}} days)</span>
            }
          </div>
        </div>
      </div>

      <div class="api-key-row">
        <input class="api-key-input" [type]="isTokenVisible ? 'text' : 'password'"
          [value]="userTokenMetadata?.token" readonly />
        <div class="eye-icon" cygovSvgIcon [svgName]="'mask-eye'" (click)="toggleTokenVisibility()">
        </div>
      </div>

      <div class="generate-btn-wrapper">
        <cygov-button class="generate-btn" [disableClick]="profileLoading"
          [fullyDisabled]="profileLoading" [buttonText]="'RE GENERATE'" [buttonWidth]="'7vw'"
          [buttonHeight]="'3vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
          (click)="reGenerateApiKey()">
        </cygov-button>
      </div>

      <div class="d-flex lato-14-n-vw pt-2">
        Learn how to use this API key in our documentation.
        <a href="{{apiDocUrl}}" target="_blank" class="arrow-link">
          <span cygovSvgIcon [svgName]="'external-link-arrow'" class="arrow-icon"></span>
        </a>
      </div>
    </div>
    }
    @else {
    <div class="section api-key-section no-token">
      <div class="section-title-no-token lato-18-n-vw">API Key Generator</div>
      <div class="generate-btn-wrapper">
        <cygov-button class="generate-btn" [buttonText]="'GENERATE'" [buttonWidth]="'6vw'"
          [buttonHeight]="'3vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
          (click)="generateApiKey()" [disableClick]="profileLoading"
          [fullyDisabled]="profileLoading">
        </cygov-button>
      </div>
    </div>
    }
    }
    <div class="horizontal-divider"></div>

    <div class="section otp-section">
      <div class="otp-toggle">
        <cygov-toggle-button [isChecked]="true" [isDisabled]="true"></cygov-toggle-button>
        <span class="remove-margin lato-14-n-vw otp-label">
          Enable OTP
        </span>
      </div>
    </div>
    <div class="horizontal-divider"></div>
  </div>
</ng-template>
<!-- Download Report Archive modal footer Content  -->
<ng-template #UpdateProfileFooter>
  <div class='profile-footer-section'>
    <cygov-button class="footer-btn save-btn" [buttonText]="'SAVE'" [buttonWidth]="'6vw'"
      [buttonHeight]="'3vh'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      [disableClick]="profileLoading" [fullyDisabled]="profileLoading" (click)="saveProfile()">
    </cygov-button>
    <cygov-button class="footer-btn cancel-btn" [buttonText]="'CANCEL'" [buttonWidth]="'6vw'"
      [buttonHeight]="'3vh'" [buttonColor]="'transparent'" [buttonBorder]="'#C5C9D1'"
      [textColor]="'#C5C9D1'" (click)="closeProfileModal()">
    </cygov-button>
  </div>
</ng-template>